var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EDF0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 32H4C1.792 32 0 30.208 0 28V4C0 1.792 1.792 0 4 0H28C30.208 0 32 1.792 32 4V28C32 30.208 30.208 32 28 32ZM12.288 24.128C19.832 24.128 23.96 17.872 23.96 12.456C23.96 12.28 23.96 12.104 23.952 11.928C24.752 11.352 25.448 10.624 26 9.8C25.264 10.128 24.472 10.344 23.64 10.448C24.488 9.944 25.136 9.136 25.448 8.176C24.656 8.648 23.776 8.984 22.84 9.168C22.088 8.368 21.024 7.872 19.848 7.872C17.584 7.872 15.744 9.712 15.744 11.976C15.744 12.296 15.784 12.608 15.848 12.912C12.44 12.744 9.416 11.104 7.392 8.624C7.04 9.232 6.84 9.936 6.84 10.688C6.84 12.112 7.568 13.368 8.664 14.104C7.992 14.08 7.36 13.896 6.808 13.592C6.808 13.608 6.808 13.624 6.808 13.648C6.808 15.632 8.224 17.296 10.096 17.672C9.752 17.768 9.392 17.816 9.016 17.816C8.752 17.816 8.496 17.792 8.248 17.744C8.768 19.376 10.288 20.56 12.08 20.592C10.672 21.696 8.904 22.352 6.984 22.352C6.656 22.352 6.328 22.336 6.008 22.296C7.816 23.448 9.976 24.128 12.288 24.128Z",
    fill: "#16449A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e74c687d08e6fc7e3651a707a9d97255.svg";
export { ForwardRef as ReactComponent };